import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import LazyIcon from '@helsenorge/designsystem-react/components/LazyIcon';
import LinkList from '@helsenorge/designsystem-react/components/LinkList';
import { getFeatureToggle } from '@helsenorge/framework-utils/hn-feature-toggle';
import SharingStatus from '../sharing-status';
import TjenesterGroup from '../tjenester-group';
import { trackFlis } from '../utils';
import styles from './styles.module.scss';
const TjenesterList = props => {
    return (_jsx(_Fragment, { children: props.groups
            .filter(group => group.tiles && group.tiles.length > 0)
            .map(group => (_jsx(TjenesterGroup, { title: group.title, children: _jsx(LinkList, { chevron: true, color: 'white', className: styles.tjenesterlist, children: group.tiles?.map(flis => (_jsxs(LinkList.Link, { href: flis.link ?? undefined, icon: _jsx(LazyIcon, { iconName: flis.image }), onClick: () => trackFlis(flis), children: [flis.title, flis.visDeltMedBarnet && props.sharingStatusText && !getFeatureToggle('NyHjelpetekst') && (_jsx(SharingStatus, { children: props.sharingStatusText }))] }, flis.title))) }) }, group.title))) }));
};
export default TjenesterList;
